import React from 'react';
import Helmet from 'react-helmet';
import { useLocation, useParams } from 'react-router-dom';
import { parse } from 'query-string';
import { Typography } from '@mui/material';

import SplashWrapper from 'retired/SplashWrapper';

const SlackInstallRedirectPage = (): JSX.Element => {
  const location = useLocation();
  const { status } = useParams();
  const query = parse(location.search);

  return (
    <SplashWrapper>
      <Helmet title="Installing Slack" />
      {status === 'success' ? (
        <>
          <Typography variant="h1" mb={3}>
            Thanks for adding us on Slack!
          </Typography>
          <h5
            style={{
              marginTop: 20,
            }}
          >
            For Slack administrators:
          </h5>
          <p>You&apos;re almost done!</p>
          <p>
            <a
              href={
                query.team && query.app
                  ? `slack://app?team=${query.team}&id=${query.app}&tab=home`
                  : 'slack://open'
              }
            >
              Open up the Slack app
            </a>{' '}
            and add Deed to a Slack channel under <em>Select Deed Slack Channel</em>.
          </p>
          <h5
            style={{
              marginTop: 20,
            }}
          >
            For Deed administrators:
          </h5>
          <p>
            Ensure that you and your Slack administrator have added Deed to a Slack channel
            following the instructions above.
          </p>
          <p>
            Then{' '}
            <a
              href={
                query.team && query.app
                  ? `slack://app?team=${query.team}&id=${query.app}&tab=home`
                  : 'slack://open'
              }
            >
              open up the Slack app
            </a>{' '}
            and click the <em>Integrate with Deed Platform</em> button to connect your Slack team to
            your company on Deed.
          </p>
        </>
      ) : null}
      {status === 'failure' ? (
        <>
          <h1
            style={{
              fontSize: 25,
              fontWeight: 600,
              marginBottom: 20,
            }}
          >
            Sorry we missed you!
          </h1>
          <h5
            style={{
              marginTop: 20,
            }}
          >
            Apologies for the inconvenience
          </h5>
          <p>
            We&apos;re here to help! Please try again later or contact{' '}
            <a
              href={`mailto:support@joindeed.com?subject=Slack failed to install! (${query.error})${
                query.team ? `[${query.team}]` : ''
              }`}
            >
              support@joindeed.com
            </a>
          </p>
        </>
      ) : null}
    </SplashWrapper>
  );
};

export default SlackInstallRedirectPage;
